import styled from '@emotion/styled';
import { css } from 'theme-ui';

const RelativeBlock = styled.div(
  css({
    position: 'relative',
  }),
);

export default RelativeBlock;
